import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import { twMerge } from 'tailwind-merge';

interface Props {
    iconKey: IconKey;
    className?: string;
    size?: string;
}
const IconBadge = ({ iconKey, className, size = '0.75rem' }: Props) => {
    return (
        <div
            className={twMerge(
                'flex items-center justify-center rounded-sm bg-gray-200 p-0.5 text-gray-600',
                className,
            )}
        >
            <Icon iconKey={iconKey} size={size} />
        </div>
    );
};

export default IconBadge;
